export default "__VITE_ASSET__6012502e__"